import { Box } from "@mui/material";
import Accordion, { accordionClasses } from "@mui/material/Accordion";
import MAccordionDetails from "@mui/material/AccordionDetails";
import MAccordionSummary, { accordionSummaryClasses } from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { Input } from "Components/Form";

export const CustomAccordion = styled(Accordion)(() => ({
  minWidth: "280px",

  "&:not(:first-of-type), &:not(:last-of-type)": {
    borderBottom: `1px solid ${colors.gray200}`,
  },
  "&:before": {
    display: "none",
  },
  [`&.${accordionClasses.expanded}`]: {
    margin: "0px !important",
  },
}));

export const AccordionSummary = styled(MAccordionSummary)(() => ({
  padding: "12px 12px !important",
  color: "#475467",
  fontWeight: 600,
  lineHeight: "24px",

  [`&.${accordionSummaryClasses.root}`]: {
    minHeight: "auto !important",
  },

  [`& .${accordionSummaryClasses.content}`]: {
    alignItems: "center",
    display: "flex",
    gap: "8px",
    margin: "0 !important",
  },
}));

export const AccordionDetails = styled(MAccordionDetails)(() => ({
  padding: "0 !important",
  display: "flex",
  flexDirection: "column",
}));

type InputContainerProps = {
  filter?: boolean;
};
export const InputContainer = styled("div", {
  shouldForwardProp: (props) => props !== "filter",
})<InputContainerProps>(({ filter }) => ({
  backgroundColor: colors.gray100,
  display: "flex",
  justifyContent: "space-between",
  padding: "12px",
  alignItems: "center",

  "& .MuiFormControl-root": {
    maxWidth: filter ? "212px" : "100%",
    width: "100%",

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: colors.gray300,
      },
      "&:hover fieldset": {
        borderColor: colors.gray300,
      },
      "&.Mui-focused fieldset": {
        borderColor: colors.gray300,
      },
      "&.Mui-focused": {
        borderColor: colors.gray300,
      },
    },
  },
}));

type SearchInputProps = {
  filter?: boolean;
};
export const SearchInput = styled(Input, {
  shouldForwardProp: (props) => props !== "filter",
})<SearchInputProps>(({ filter }) => ({
  borderRadius: "3px",
  minWidth: filter ? "90%" : "100%",
}));

export const Image = styled("img")(() => ({
  padding: "8px",
  width: "36px",
  height: "36px",
}));

export const LeftPanelItem = styled(Box)(() => ({
  border: `1px solid ${colors.white}`,
  minWidth: "200px",
  overflowY: "scroll",
  "&::-webkit-scrollbar": {
    width: "4px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: colors.gray500,
    borderRadius: "8px",
  },
}));

export const LoadMoreContainer = styled("div")({
  paddingBottom: "12px",
  paddingLeft: "12px",
  cursor: "pointer",
  "& span": {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 600,
    color: colors.brandBlue500,
    lineHeight: "20px",
    letterSpacing: "0.5px",
  },
});

export const Badge = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  padding: "0px 4px ",

  backgroundColor: colors.gray500,
  borderRadius: "100px",
  height: "16px",
  width: "fit-cotent",
  color: colors.white,
  fontFamily: "Manrope",
  fontSize: "11px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  textAlign: "center",
}));

type IFilterByOptionsContainer = {
  active?: boolean;
};

export const FilterOptionsWrapper = styled("div")(() => ({
  alignItems: "flex-start",
  display: "flex",
  justifyContent: "center",
  gap: "0px",
}));

export const FilterByOptionsContainer = styled("div", {
  shouldForwardProp: (props) => props !== "active",
})<IFilterByOptionsContainer>(({ active }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  backgroundColor: active ? "#6670851F" : "transparent",
  borderRadius: "8px",
  cursor: "pointer",
  minHeight: "28px",
  minWidth: "28px",
  padding: "8px",

  "&:hover": {
    backgroundColor: "#6670851F",
  },
}));

export const CountBadge = styled("div")(() => ({
  alignContent: "center",
  display: "flex",
  justifyContent: "center",

  width: "fit-content",
  height: "16px",
  backgroundColor: colors.brandBlue500,
  fontSize: "11px !important",
  fontWeight: 600,
  lineHeight: "16px",
  borderRadius: "20px",
  color: colors.white,
  textAlign: "center",
  fontStyle: "normal",
  letterSpacing: "0.5px",
  padding: "0 4px",
  marginLeft: "-8px",
}));
